import React, { useState } from 'react';

const SupportCard = () => {
    const [showToast, setShowToast] = useState(false);

    const handleEmailClick = (e) => {
        if (e) e.preventDefault();
        navigator.clipboard.writeText("Support@stenope.ai");
        setShowToast(true);
        setTimeout(() => {
            setShowToast(false);
        }, 3000);
        
        // Open default mail client in background
        setTimeout(() => {
            window.location.href = "mailto:Support@stenope.ai";
        }, 100);
    };

    return (
        <div className="selection-card-new support-card">
            <div className="card-top-accent support-accent"></div>
            <div className="card-icon-container">
                <img src="/support.png" alt="Support" className="card-icon-img" />
            </div>
            <span className="card-tag support-tag">💬 SUPPORT HUB</span>
            <h2>Get in touch with our team</h2>
            <p>Have questions or need assistance? Our support team is here to help you.</p>
            <div className="support-actions-container">
                <a href="mailto:Support@stenope.ai" className="support-action-link email-link" onClick={handleEmailClick}>
                    <svg className="support-link-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" style={{ width: '16px', height: '16px' }}>
                        <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"></path>
                        <polyline points="22,6 12,13 2,6"></polyline>
                    </svg>
                    <span>Email Support</span>
                </a>
                <a href="https://discord.gg/fZ3TBqRSKs" target="_blank" rel="noopener noreferrer" className="support-action-link discord-link">
                    <svg className="support-link-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" style={{ width: '16px', height: '16px' }}>
                        <path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z"></path>
                    </svg>
                    <span>Join Discord</span>
                </a>
            </div>
            {showToast && (
                <div className="support-toast fade-in">
                    📧 Support Email copied!
                </div>
            )}
        </div>
    );
};

export default SupportCard;
